<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout row wrap v-if="!loading&&topCost">
            <v-flex xs12 >
                <vue-plotly :data="topCost.data" :white-mode="whiteMode"
                            :layout="topCost.layout" :options="{}"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import {getIssueSummary} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import VuePlotly from "./../VuePlotly";

export default {
    props: {
        dateRange: {type: Object, default: null},
        whiteMode: {type: Boolean, default: false},
        height: {type: Number, default: null},
        leftmarg: {type: Number, default: null},
    },
    components: {LoadingProgressBar, VuePlotly},
    computed: {},
    name: 'CostBreakdownWidget',
    watch: {
        dateRange() {
            this.refresh()
        },
    },
    data: function () {
        return {
            loading: true,
            timeout: null,
            topCost: null,
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.getData, 200);
        },
        async getData() {
            let me = this
            if (this.dateRange) {
                this.loading = true
                getIssueSummary({
                    'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                    'date_range': me.dateRange
                }).then(function (summaryResult) {
                    let totalCost = summaryResult.summary.reduce((sum, x) => sum + x.cost, 0)
                    let mostExpensive = [...summaryResult.summary].sort(function (a, b) {
                        return b.cost - a.cost
                    }).filter(x => x.cost > 0);
                    me.topCost = {
                        "data": [{
                            type: 'bar',
                            x: mostExpensive.map(x => x.cost).reverse(),
                            y: mostExpensive.map(x => x.issue).reverse(),
                            orientation: 'h',
                        }],
                        "layout": {
                            title: me.$options.filters.translate("Most Expensive Faults. Total Cost") + " : " + totalCost.toFixed(2) + " kWh",
                            autosize: true,
                            margin: {
                                "l": me.leftmarg ? me.leftmarg : 550,
                                "r": 50,
                                "t": 50,
                                "pad": 1
                            },
                            height: me.height ? me.height : Math.max(400, 25 * mostExpensive.length),
                        }
                    }
                    me.loading = false
                })
            }
        }
    },
}
</script>
